import { FormControlLabel, Checkbox, Grid, TextField } from '@mui/material';
import { formatInputPhoneNumber } from '../../../helpers';
import { StatesDropdown } from '../../../components';

export const SupplierFields = ({
  setFieldValue,
  values,
  isFormDisabled,
  touched,
  errors,
  handleBlur
}) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          autoComplete="nope"
          label="Supplier Name"
          name="workplace"
          value={values.workplace}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          inputProps={{
            'data-lpignore': 'true'
          }}
          error={touched.workplace && errors && errors.workplace ? true : false}
          helperText={touched.workplace && errors && errors.workplace}
          onChange={e => setFieldValue('workplace', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Sage Vendor ID"
          name="sageVendorId"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.sageVendorId}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => setFieldValue('sageVendorId', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="First Name"
          name="agency"
          value={values.firstName}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => {
            setFieldValue('firstName', e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Last Name"
          name="agency"
          value={values.lastName}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => {
            setFieldValue('lastName', e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          onChange={e => setFieldValue('email', e.target.value)}
          fullWidth
          id="email"
          label="Email"
          size="small"
          name="email"
          onBlur={handleBlur}
          autoComplete="off"
          value={values.email}
          disabled={isFormDisabled}
          inputProps={{
            'data-lpignore': true // Last Pass disable auto-fill
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          onChange={e => setFieldValue('additionalContactEmails', e.target.value)}
          fullWidth={true}
          id="email"
          label="Additional Contact Emails"
          size="small"
          autoComplete="off"
          value={values.additionalContactEmails}
          disabled={isFormDisabled}
          inputProps={{
            'data-lpignore': true // Last Pass disable auto-fill
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Phone Number"
          name="phone"
          value={values.phoneNumber}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => {
            setFieldValue('phoneNumber', formatInputPhoneNumber(e.target.value));
          }}
          error={Boolean(touched.phoneNumber && errors.phoneNumber)}
          helperText={touched.phoneNumber && errors.phoneNumber}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Cell Phone Number"
          name="phone"
          value={values.cellPhoneNumber}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => {
            setFieldValue('cellPhoneNumber', formatInputPhoneNumber(e.target.value));
          }}
          error={Boolean(touched.cellPhoneNumber && errors.cellPhoneNumber)}
          helperText={touched.cellPhoneNumber && errors.cellPhoneNumber}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Fax"
          name="phone"
          value={values.fax}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => {
            setFieldValue('fax', formatInputPhoneNumber(e.target.value));
          }}
          error={Boolean(touched.fax && errors.fax)}
          helperText={touched.fax && errors.fax}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Address Line 1"
          name="address"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.address}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.address && errors && errors.address ? true : false}
          helperText={touched.address && errors && errors.address}
          onChange={e => setFieldValue('address', e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Address Line 2"
          name="address2"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.address2}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.address2 && errors && errors.address2 ? true : false}
          helperText={touched.address2 && errors && errors.address2}
          onChange={e => setFieldValue('address2', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="City"
          name="city"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.city}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.city && errors && errors.city ? true : false}
          helperText={touched.city && errors && errors.city}
          onChange={e => setFieldValue('city', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <StatesDropdown
          value={values.state}
          handleChange={value => {
            setFieldValue('state', value as string);
          }}
          isAdminPortal={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="ZIP"
          name="zip"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.zip}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.zip && errors && errors.zip ? true : false}
          helperText={touched.zip && errors && errors.zip}
          onChange={e => setFieldValue('zip', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControlLabel
          color="primary"
          control={
            <Checkbox
              checked={values.supplierAcceptsBidRequests}
              id="supplierAcceptsBidRequests"
              onChange={(_, checked) => setFieldValue('supplierAcceptsBidRequests', checked)}
            />
          }
          label="Supplier Accepts Bid Requests"
        />
      </Grid>
    </>
  );
};
